export enum MachineMeasurementsEnum {
    MULTIPLIER = 'Multiplicador',
    VELOCITY = 'Golpes x minuto',
}
